import Button from '@mui/material/Button';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Stack } from '@mui/material';

export default function ExportButton(props) {

    let {onClick, ...rest} = props;

    function handleClick() {
        if(onClick) {
            onClick();
        }
    }

    return <>
      <Stack alignItems='flex-end'>
            <Button variant="text" onClick={handleClick} {...rest}><FileDownloadIcon fontSize='small'/> Export</Button>
        </Stack>
    </>
}
